

























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { User, Info } from '@/types/core';

import tippy from 'tippy.js';

import VueError from '@/components/VueError.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import GroupAccessView from '@/components/access/GroupAccessView.vue';


@Component({
  components:{
    VueError,
    GroupAccessView,
    TimestampAgo
  }
})
export default class UserRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) user!: User;
  @Prop({ default: 0,  type: Number}) index!: number;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  
  async mounted() {
    // nothing here yet

    tippy('[data-tippy-content]');
  }
}
